import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, startWith } from 'rxjs/operators';
import { ClienteOutput } from 'src/app/@shared/models/cliente.model';
import { ClienteService } from 'src/app/services/cliente/cliente.service';

@Component({
  selector: 'input-pesquisa-cliente',
  templateUrl: './input-pesquisa-cliente.component.html',
  styleUrls: ['./input-pesquisa-cliente.component.scss']
})
export class InputPesquisaClienteComponent implements OnInit {
  public sub: Subscription;
  public listaClientes: ClienteOutput[];
  public requerido: boolean = false;

  @Input() placeHolder: string = "Cliente";
  @Input() control: FormControl;

  @Output() valorSelecionado = new EventEmitter<ClienteOutput>();

  constructor(private clienteService: ClienteService) { }

  ngOnInit() {
    if (this.control.errors !== null) {
      this.requerido = this.control.errors['required'];
    }

    this.sub = this.control.valueChanges.pipe(startWith(''), debounceTime(200)).subscribe(val => {
      if (val == null) return;
      if (val.length >= 3) {
        this.clienteService.obterPesquisaClientePorNome(val).subscribe(data => {
          this.listaClientes = data;
        })
      } else { this.listaClientes = null }
    })
  }

  selecionado(value: any) {
    this.valorSelecionado.emit(value.option.value);
  }

  displayFn(value: ClienteOutput): string {
    if (value && typeof value === 'object') {
      return `${value.nome} - ${value.id}`;
    }
    return '';
  }

  clearCidade() {
    this.control.patchValue('');
  }
}